// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOG_REPORT_POST = "Nahl\u00e1sit p\u0159\u00edsp\u011bvek";
export const CHANGE_DATE_TITLE_AND_DESCRIPTION = "Zm\u011b\u0148 n\u00e1zev a popis";
export const DELETE_ALBUM = "Vyma\u017e album";
export const PB_IGNORE_POSTS_FROM_USER_username = "Nezobrazuj mi p\u0159\u00edsp\u011bvky od %(username)s";
export const REMOVE_FROM_FEED = "Odstranit z feedu";
export const REORDER_PHOTOS = "Zm\u011b\u0148 po\u0159ad\u00ed fotek";
export const RETURN_TO_FEED = "Vr\u00e1tit do feedu";
export const SEND_HEART_TO_username = "Po\u0161li srd\u00ed\u010dko %(username)s";
export const SHOW_USERS_WHO_LIKED_THIS_POST = "Zobraz u\u017eivatelky, kter\u00fdm se to l\u00edb\u00ed";
